"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amount = void 0;
const TupleSlice4_1 = require("../boc/TupleSlice4");
function amount(client) {
    return async (seqno, address, name) => {
        let executed = await client.runMethod(seqno, address, name);
        if (executed.exitCode !== 0 && executed.exitCode !== 1) {
            throw Error('Exit code: ' + executed.exitCode);
        }
        let parsed = new TupleSlice4_1.TupleSlice4(executed.result);
        return parsed.readBigNumber();
    };
}
exports.amount = amount;
